import { sentryLog } from "../../../tools/sentry";
import { formSet } from "../../gvc/testNewForm/utils";
import { validationFns } from "../../../components/form/validations";
import { CloudAccountInput } from "../../../schema/types/cloudaccount/input";
import { parseLink } from "../../../utils/linkParser/linkParser";

export function getValidator(id: string) {
  return async function validator(v: CloudAccountInput): Promise<boolean | null> {
    // setup
    formSet(id, `meta.valid`, false);
    formSet(id, `meta.validating`, true);
    formSet(id, `errors`, {});
    formSet(id, `warnings`, {});

    const e: Partial<Record<string, { message: string }>> = {};
    const w: Partial<Record<string, { message: string }>> = {};

    function setError(path: string, message: string) {
      const currentError = e[path];
      if (currentError) {
        return;
      }
      e[path] = { message: message };
    }

    function setWarning(path: string, message: string) {
      const currentError = e[path];
      if (currentError) {
        return;
      }
      const currentWarning = w[path];
      if (currentWarning) {
        return;
      }
      w[path] = { message: message };
    }

    // setup end

    try {
      const fs = validationFns("Name");
      for (const f of [fs.required, fs.name]) {
        const r = f(v.name);
        if (r !== true) {
          setError(`name`, r);
        }
      }

      if (v.description.length > 250) {
        setError(`description`, `Description can be at most 250 characters`);
      }

      // tags start
      for (const tagIndexStr in v.tags) {
        const tagIndex = Number(tagIndexStr);
        const tag = v.tags[tagIndex];
        if (!tag.name) {
          setError(`tags.${tagIndex}.name`, "Tag key is required");
          setError(`tagsroot`, "Tag keys are required");
        }
      }

      if (v.tags.length > 50) {
        setError(`tagsroot`, "Tags cannot be more than 50 items");
      }
      // tags end

      if (v.provider === "aws") {
        if (v.aws.method === "roleArn") {
          if (!v.aws.roleArn) {
            setError(`aws.roleArn`, "Role ARN is required");
          } else {
            const regex = /^arn:(aws|aws-us-gov|aws-cn):iam::[0-9]+:role\/.+/;
            if (!regex.test(v.aws.roleArn)) {
              setError(`aws.roleArn`, `Role ARN must be a valid match for regex: ${regex}`);
            }
          }
        }
      }
      if (v.provider === "azure") {
        if (v.azure.type === "secret") {
          if (!v.azure.secret?.link) {
            setError(`azure.secret`, "Secret is required");
          } else {
            const parsedLink = parseLink(v.azure.secret.link, { useInputCtx: true });
            if (!parsedLink.isValid) {
              setError(`azure.secret`, parsedLink.errorMessage);
            }
          }
        } else {
          // connector
          if (!v.azure.url) {
            setError(`azure.url`, "URL is required");
          }
          if (!v.azure.code) {
            setError(`azure.code`, "Code is required");
          }
        }
      }
      // if (v.provider === "gcp") {
      // }
      if (v.provider === "ngs") {
        if (!v.ngs.secret?.link) {
          setError(`ngs.secret`, "Secret is required");
        } else {
          const parsedLink = parseLink(v.ngs.secret.link, { useInputCtx: true });
          if (!parsedLink.isValid) {
            setError(`ngs.secret`, parsedLink.errorMessage);
          }
        }
      }

      // setup
      for (const path of Object.keys(e)) {
        const value = e[path];
        formSet(id, `errors.${path}`, value);
      }
      for (const path of Object.keys(w)) {
        const value = w[path];
        formSet(id, `warnings.${path}`, value);
      }

      const hasErrors = Object.keys(e).length > 0;

      formSet(id, `meta.valid`, !hasErrors);
      formSet(id, `meta.validating`, false);

      return hasErrors;
    } catch (e) {
      sentryLog("cloudaccount validator error", { "data.error": e.message });
      formSet(id, `errors`, {
        root: { message: "An unexpected error occurred. This has been logged and we will fix it." },
      });
      return true;
    }
  };
}
